import React from "react";

import { ProductMarketplaceCategory } from "custom-types/Product";

import Image from "components/Image";

import { ProductBreadcrumbs } from "../ProductCategoryBreadcrumbs";

type HeroBannerProps = {
  category?: ProductMarketplaceCategory;
  imageSrc: string;
  subcategory?: ProductMarketplaceCategory;
  children?: React.ReactNode;
};

export const HeroBanner: React.FC<HeroBannerProps> = ({
  category,
  children,
  imageSrc,
  subcategory,
}) => {
  return (
    <>
      <div
        className="hero mb-sm overflow-hidden relative"
        data-testid="hero-banner"
      >
        <Image
          src={imageSrc}
          alt="Shop nearby"
          sizes={[544, 767, 1023, 1440, null, 767]}
          background
          disableLazyLoad
        />
        <div className="hero-container container absolute left-0 right-0 top-0">
          <div className="absolute cm-z-1 left-0 top-0 w-full text-white">
            <ProductBreadcrumbs category={category} subcategory={subcategory} />
          </div>
          {children}
        </div>
      </div>
      <style jsx>{`
        .hero {
          height: 240px;
        }

        .hero-image {
          height: 100%;
          object-position: 50% 50%;
        }

        .hero-container {
          bottom: 21px;
        }

        @media screen and (min-width: 768px) {
          .hero {
            height: 370px;
          }

          .hero-container {
            bottom: 40px;
          }
        }
      `}</style>
    </>
  );
};
